import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=ba6562c6&scoped=true"
import script from "./button-group.ts?vue&type=script&lang=ts&external"
export * from "./button-group.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6562c6",
  null
  
)

export default component.exports